import { UserInfoDataType } from "store/useUserStore";

export class UserManager {
  userId: string | null;
  userInfo: UserInfoDataType | null;
  accessToken: string | null;
  refreshToken: string | null;
  KEY: {
    USER_ID: string;
    ACCESS_TOKEN: string;
    REFRESH_TOKEN: string;
    USER_INFO: string;
  };

  constructor() {
    this.userId = null;
    this.userInfo = null;
    this.accessToken = null;
    this.refreshToken = null;
    this.KEY = {
      USER_ID: "UserId",
      ACCESS_TOKEN: "AccessToken",
      REFRESH_TOKEN: "RefreshToken",
      USER_INFO: "UserInfo",
    };
    this.init();
  }

  init() {
    this.getUserId();
    this.getAccessToken();
    this.getUserInfo();
  }

  checkLogin(): boolean {
    const token: string | null = this.getAccessToken();
    if (token) return true;
    else return false;
  }
  getUserId(): string | null {
    this.userId = window.sessionStorage.getItem(this.KEY.USER_ID);
    return this.userId;
  }
  getUserInfo(): UserInfoDataType | null {
    const userInfoJson = window.sessionStorage.getItem(this.KEY.USER_INFO);
    if (userInfoJson) {
      this.userInfo = JSON.parse(userInfoJson);
      return this.userInfo;
    } else return null;
  }
  getAccessToken(): string | null {
    this.accessToken = window.sessionStorage.getItem(this.KEY.ACCESS_TOKEN);
    return this.accessToken;
  }
  getRefreshToken(): string | null {
    this.refreshToken = window.sessionStorage.getItem(this.KEY.REFRESH_TOKEN);
    return this.refreshToken;
  }
  setUserId(userId: string) {
    window.sessionStorage.setItem(this.KEY.USER_ID, userId);
  }
  setUserInfo(userInfo: UserInfoDataType) {
    window.sessionStorage.setItem(this.KEY.USER_INFO, JSON.stringify(userInfo));
  }
  setAccessToken(accessToken: string) {
    window.sessionStorage.setItem(this.KEY.ACCESS_TOKEN, accessToken);
    this.getAccessToken();
  }
  setRefreshToken(refreshToken: string) {
    window.sessionStorage.setItem(this.KEY.REFRESH_TOKEN, refreshToken);
    this.getRefreshToken();
  }
  clear() {
    window.sessionStorage.removeItem(this.KEY.ACCESS_TOKEN);
    window.sessionStorage.removeItem(this.KEY.REFRESH_TOKEN);
    window.sessionStorage.removeItem(this.KEY.USER_ID);
    window.sessionStorage.removeItem(this.KEY.USER_INFO);

    this.accessToken = null;
    this.refreshToken = null;
    this.userId = null;
    this.userInfo = null;
  }
}
